"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPurchaseToJSON = exports.NftPurchaseFromJSONTyped = exports.NftPurchaseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NftPurchaseFromJSON(json) {
    return NftPurchaseFromJSONTyped(json, false);
}
exports.NftPurchaseFromJSON = NftPurchaseFromJSON;
function NftPurchaseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'status': (0, _1.NftPurchaseStatusFromJSON)(json['status']),
        'log': (json['log'].map(_1.NftPurchaseLogFromJSON)),
        'total': json['total'],
        'stripeTotal': json['stripeTotal'],
        'dpay': json['dpay'],
        'fiatInDpay': json['fiatInDpay'],
        'dpayTransaction': !(0, runtime_1.exists)(json, 'dpayTransaction') ? undefined : json['dpayTransaction'],
        'dpayTransactionRefund': !(0, runtime_1.exists)(json, 'dpayTransactionRefund') ? undefined : json['dpayTransactionRefund'],
        'paymentMethodId': !(0, runtime_1.exists)(json, 'paymentMethodId') ? undefined : json['paymentMethodId'],
        'paymentIntentId': !(0, runtime_1.exists)(json, 'paymentIntentId') ? undefined : json['paymentIntentId'],
        'paymentIntentRefundId': !(0, runtime_1.exists)(json, 'paymentIntentRefundId') ? undefined : json['paymentIntentRefundId'],
        'walletAddress': json['walletAddress'],
        'coinbaseChargeId': !(0, runtime_1.exists)(json, 'coinbaseChargeId') ? undefined : json['coinbaseChargeId'],
        'isCoinbase': !(0, runtime_1.exists)(json, 'isCoinbase') ? undefined : json['isCoinbase'],
        'cartItems': (json['cartItems'].map(_1.NftPurchaseCartItemFromJSON)),
    };
}
exports.NftPurchaseFromJSONTyped = NftPurchaseFromJSONTyped;
function NftPurchaseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'user': value.user,
        'status': (0, _1.NftPurchaseStatusToJSON)(value.status),
        'log': (value.log.map(_1.NftPurchaseLogToJSON)),
        'total': value.total,
        'stripeTotal': value.stripeTotal,
        'dpay': value.dpay,
        'fiatInDpay': value.fiatInDpay,
        'dpayTransaction': value.dpayTransaction,
        'dpayTransactionRefund': value.dpayTransactionRefund,
        'paymentMethodId': value.paymentMethodId,
        'paymentIntentId': value.paymentIntentId,
        'paymentIntentRefundId': value.paymentIntentRefundId,
        'walletAddress': value.walletAddress,
        'coinbaseChargeId': value.coinbaseChargeId,
        'isCoinbase': value.isCoinbase,
        'cartItems': (value.cartItems.map(_1.NftPurchaseCartItemToJSON)),
    };
}
exports.NftPurchaseToJSON = NftPurchaseToJSON;
